import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"
import { CompanySalaryInsightsResultsPage } from "./pages/CompanySalaryInsightsResultsPage"
import EmploymentComparatorPage from "./pages/EmploymentComparatorPage/EmploymentComparatorPage"

const CompanyToolkitPage = lazy(() => import("./pages/CompanyToolkitPage"))
const StaffSalaryInsightsLandingPage = lazy(() => import("./pages/StaffSalaryInsightsLandingPage"))
const GlobalSalaryConverterLandingPage = lazy(
  () => import("./pages/GlobalSalaryConverterPage/GlobalSalaryConverterLandingPage"),
)
const GlobalSalaryConverterResultPage = lazy(
  () => import("./pages/GlobalSalaryConverterPage/GlobalSalaryConverterResultPage"),
)
const EmploymentCostComparisonPage = lazy(() => import("~/app/pages/EmploymentCostComparisonPage"))

export const staffOysterIntelligenceRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: "toolkit",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanyToolkitPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "salary-insights-tool",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <StaffSalaryInsightsLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-compensation-calculator",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <StaffSalaryInsightsLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "salary-insights-tool/results",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanySalaryInsightsResultsPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-salary-converter",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-salary-converter/results",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterResultPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-compensation",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "employment-comparator",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EmploymentComparatorPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "employment-cost-comparison",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EmploymentCostComparisonPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  DeprecatedFullScreen: [],
}
